export enum NodeType {
	Document,
	DocumentType,
	Element,
	Text,
	CDATA,
	Comment,
}

export type DocumentNode = {
	type: NodeType.Document;
	childNodes: Array<SerializedNodeWithId>;
};
export type DocumentTypeNode = {
	type: NodeType.DocumentType;
	name: string;
	publicId: string;
	systemId: string;
};
export type Attributes = {
	[key: string]: string | number | boolean;
};
export type ElementNode = {
	type: NodeType.Element;
	tagName: string;
	attributes: Attributes;
	childNodes: Array<SerializedNodeWithId>;
	isSVG?: true;
	needBlock?: boolean;
};
export type TextNode = {
	type: NodeType.Text;
	textContent: string;
	isStyle?: true;
	isHtml?: true;
};
export type CDataNode = {
	type: NodeType.CDATA;
	textContent: string;
};
export type CommentNode = {
	type: NodeType.Comment;
	textContent: string;
};

export type SerializedNode =
	| DocumentNode
	| DocumentTypeNode
	| ElementNode
	| TextNode
	| CDataNode
	| CommentNode;

export type SerializedNodeWithId = SerializedNode & { id: number };
